import CarRegLookup from './CarRegLookup';
export default CarRegLookup;